import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useLastRoute = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    
    if (!pathname.includes('/auth')) {
      localStorage.setItem('lastRoute', pathname);
    }

    return () => {
      
    };
    
  }, [pathname]);
};

export default useLastRoute; 